export default function(_el) {

  const input = _el.querySelector('input');
  const buttons = _el.querySelectorAll('button');
  
  let maxVal;

  const init = () => {
    maxVal = parseInt(_el.dataset.jsIncrementMax, 10) || 99;
    initInput();
    initButtons();
  }

  const initInput = () => {
    input.value = Math.max(0, Math.min(maxVal, input.value));
  }
  
  const initButtons = () => {
    buttons[0].disabled = (input.value <= 0) ? true : false;
    buttons[1].disabled = (input.value >= maxVal) ? true : false;
  }

  /**
   *    Event Handlers.
   */
  input.addEventListener('blur', init);

  document.body.addEventListener('incrementsInit', init);

  [...buttons].forEach(button => {
    button.addEventListener('click', e => {
      
      e.preventDefault();
      const btn = e.target.closest('button');
      const newVal = parseInt(input.value) + parseInt(btn.dataset.jsIncrementAmount);
      input.value = Math.max(0, Math.min(maxVal, newVal));
      
      // Trigger custom event.
      const incrementChangeEvent = new CustomEvent("incrementChange", { 
        bubbles: true,
        detail: {
          newval: input.value
        } 
      });
      _el.dispatchEvent(incrementChangeEvent);
      
      initButtons();
    })
  });

  // Let's go!
  init();
}